"use client";

import { useEffect, useState } from "react";
import styles from "./SideNavigation.module.scss";
import Menu from "@/components/Navigation/Menu/Menu";

export default function SideNavigation() {
  const [isClose, setClose] = useState<boolean>(true);

  const changeWidth = (isOpen: boolean) => {
    const newWidth = isOpen ? "240px" : "64px";
    document.documentElement.style.setProperty("--side-nav-width", newWidth);
  };

  useEffect(() => {
    changeWidth(isClose);
  }, [isClose]);

  const toggleBurger = () => {
    setClose(!isClose);
    changeWidth(isClose);
  };

  return (
    <div className={`${styles.navigation} ${isClose ? styles.close : styles.open}`}>
      <button
        className={styles.burger_btn}
        onClick={() => {
          toggleBurger();
        }}
      >
        {isClose ? (
          <svg
            className={styles.burger_btn__icon}
            viewBox="0 0 7 12"
            fill="currentColor"
            width="18"
            height="100%"
          >
            <use href="/images/sprite.svg#arrow-1-left"></use>
          </svg>
        ) : (
          <svg
            viewBox="0 0 16 10"
            fill="currentColor"
            width="18"
            height="100%"
            className={styles.burger_btn__icon}
          >
            <use href="/images/sprite.svg#burger-small" />
          </svg>
        )}
      </button>

      <div className={styles.body}>
        <Menu isClose={isClose} />
      </div>
    </div>
  );
}
